unit UBarcodeScannerConfig;

interface

uses
  UWebBarcodeScanner, JS;

type
  TBarcodeScannerConfig = class
  private
    FBarcodeTypes: TBarcodeTypes;
    FScannerBeep: Boolean;
    procedure ClearValues;
    procedure SetValues(Json: string);
    procedure SetBarcodeTypes(const Value: TBarcodeTypes);
    procedure SetScannerBeep(const Value: Boolean);
  public
    constructor Create; overload;
    constructor Create(Json: string); overload;
    property BarcodeTypes: TBarcodeTypes read FBarcodeTypes
      write SetBarcodeTypes;
    property ScannerBeep: Boolean read FScannerBeep write SetScannerBeep;
  end;

implementation

uses
  UEssentialHelper;

{ TBarcodeScannerConfig }

procedure TBarcodeScannerConfig.ClearValues;
begin
  Self.BarcodeTypes := [];
  Self.ScannerBeep := true;
end;

constructor TBarcodeScannerConfig.Create;
begin
  Self.ClearValues;
end;

constructor TBarcodeScannerConfig.Create(Json: string);
begin
  Self.SetValues(Json);
end;

procedure TBarcodeScannerConfig.SetBarcodeTypes(const Value: TBarcodeTypes);
begin
  FBarcodeTypes := Value;
end;

procedure TBarcodeScannerConfig.SetScannerBeep(const Value: Boolean);
begin
  FScannerBeep := Value;
end;

procedure TBarcodeScannerConfig.SetValues(Json: string);
var
  obj: TJsObject;
  s, t: string;
  bt: TBarcodeType;
begin
  Self.ClearValues;
  obj := TJsJson.parseObject(Json);
  if obj['BarcodeTypes'] <> nil then
  begin
    s := string(obj['BarcodeTypes']);
    while s <> '' do
    begin
      t := Cut(s, ',');
      bt := TBarcodeScanner.StrToBarcodeType(t);
      Self.BarcodeTypes := Self.BarcodeTypes + [bt];
    end;
  end;
  if obj['ScannerBeep'] <> nil then
    Self.ScannerBeep := StrToBoolean(string(obj['ScannerBeep']));
end;

end.
